import { DiscountCodesList } from "./styles";
export default DiscountCodesList;
